import { createSelector } from 'reselect';
import { isExternalVideo } from '@wix/wix-vod-shared/src/common/ui-selectors/video/video-origin';
import { canAccessFullVideo } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';
import { hasTrailer, isTrailerPreviewTypeEnabled } from '@wix/wix-vod-shared/src/common/ui-selectors/video/preview';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';
import { prepareVideoCards } from '@wix/wix-vod-shared/src/widget/utils/video-cards';

export const isVideoCardsEnabled = createSelector(
  ({ currentSiteUser }, { videoItem, channelData }) => ({ currentSiteUser, videoItem, channelData }),
  ({ currentSiteUser, videoItem, channelData }) =>
    videoItem &&
    !isExternalVideo(videoItem) &&
    (
      hasTrailer(videoItem) && isTrailerPreviewTypeEnabled(videoItem) ?
        canAccessFullVideo(channelData, videoItem, currentSiteUser) :
        true
    )
);

export const getVideoCardsList = state => state.videoCards;
export const getWidgetVideoCards = ({ thumbnailSize, imageHost }) => createSelector(
  getVideoCardsList,
  getChannelForWidget,
  (videoCards, channelData) => prepareVideoCards({
    channelId: channelData.id,
    videoCards,
    thumbnailSize,
    imageHost,
  })
);



// WEBPACK FOOTER //
// ./src/widget/selectors/video-cards.js